// infinite-scroll.js - גלילה אינסופית

class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('.product-list');
    this.pagination = document.querySelector('.pagination');

    if (!this.container) return;

    // קובע את מספר העמודים הכולל מהפאגינציה של עמוד 1
    this.totalPages = this.detectTotalPages();
    this.currentPage = 1;
    this.buffer = [];
    this.bufferIndex = 0;
    this.productsPerLoad = 4;
    this.busy = false;
    this.seenProductIds = new Set();

    // שומר את ה-IDs של המוצרים שכבר מוצגים בעמוד 1
    this.collectVisibleProductIds();

    console.log('🚀 גלילה אינסופית - סך הכל', this.totalPages, 'עמודים');

    if (this.totalPages <= 1) {
      console.log('📄 עמוד אחד בלבד, לא צריך גלילה אינסופית');
      if (this.pagination) this.pagination.style.display = 'none';
      return;
    }

    this.init();
  }

  detectTotalPages() {
    if (!this.pagination) return 1;

    let maxPage = 1;
    const links = this.pagination.querySelectorAll('a[href]');
    for (const link of links) {
      const match = link.getAttribute('href').match(/[?&]page=(\d+)/);
      if (match) {
        const num = parseInt(match[1]);
        if (num > maxPage) maxPage = num;
      }
    }

    // גם בודק את הטקסט של pagination parts (מספרי עמודים)
    const spans = this.pagination.querySelectorAll('.pagination__link');
    for (const span of spans) {
      const num = parseInt(span.textContent.trim());
      if (!isNaN(num) && num > maxPage) maxPage = num;
    }

    return maxPage;
  }

  collectVisibleProductIds() {
    const cards = this.container.querySelectorAll('product-card[handle]');
    cards.forEach(card => {
      const handle = card.getAttribute('handle');
      if (handle) this.seenProductIds.add(handle);
    });
    console.log('📋 מוצרים בעמוד 1:', this.seenProductIds.size);
  }

  init() {
    if (this.pagination) {
      this.pagination.style.display = 'none';
    }

    this.createLoader();

    // טוען עמוד 2 מראש
    this.fetchPage(2);

    window.addEventListener('scroll', () => this.checkScroll(), { passive: true });
  }

  createLoader() {
    const loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader';
    loader.innerHTML = `
      <div class="infinite-scroll-spinner-wrapper">
        <div class="infinite-scroll-spinner"></div>
        <p class="infinite-scroll-text">טוען מוצרים...</p>
      </div>
    `;
    this.loader = loader;
    this.container.parentNode.insertBefore(loader, this.container.nextSibling);
  }

  checkScroll() {
    if (this.busy) return;
    if (this.bufferIndex >= this.buffer.length && this.currentPage >= this.totalPages) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercent = (scrollTop + windowHeight) / documentHeight;

    if (scrollPercent > 0.7) {
      this.showNext();
    }
  }

  async fetchPage(pageNum) {
    if (pageNum > this.totalPages) return;

    const url = new URL(window.location.href);
    url.searchParams.set('page', pageNum);

    console.log('🔄 טוען עמוד', pageNum, 'מתוך', this.totalPages);

    try {
      const response = await fetch(url.toString());
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const productList = doc.querySelector('.product-list');
      if (!productList) return;

      const products = Array.from(productList.children).filter(el =>
        !el.classList.contains('product-list__promo')
      );

      // בדיקת כפילויות לפי handle של product-card
      const newProducts = [];
      for (const product of products) {
        const card = product.matches('product-card[handle]') ? product : product.querySelector('product-card[handle]');
        const handle = card ? card.getAttribute('handle') : null;

        if (handle && this.seenProductIds.has(handle)) {
          continue; // דילוג על כפילות
        }

        if (handle) this.seenProductIds.add(handle);
        newProducts.push(product);
      }

      if (newProducts.length === 0) {
        console.log('⚠️ כל המוצרים כפולים - עוצר');
        this.currentPage = this.totalPages;
        return;
      }

      this.buffer.push(...newProducts);
      this.currentPage = pageNum;
      console.log('✅ עמוד', pageNum, '-', newProducts.length, 'מוצרים חדשים. בבאפר:', this.buffer.length - this.bufferIndex);
    } catch (error) {
      console.error('❌ שגיאה בטעינת עמוד', pageNum, error);
    }
  }

  async showNext() {
    if (this.busy) return;
    this.busy = true;

    // אם אין מוצרים בבאפר, צריך לטעון עמוד חדש
    if (this.bufferIndex >= this.buffer.length) {
      const nextPage = this.currentPage + 1;
      if (nextPage > this.totalPages) {
        console.log('🏁 הוצגו כל המוצרים');
        this.busy = false;
        this.hideLoading();
        return;
      }

      this.showLoading();
      await this.fetchPage(nextPage);

      if (this.bufferIndex >= this.buffer.length) {
        console.log('🏁 אין עוד מוצרים');
        this.busy = false;
        this.hideLoading();
        return;
      }
    }

    // מציג 4 מוצרים מהבאפר
    const batch = this.buffer.slice(
      this.bufferIndex,
      this.bufferIndex + this.productsPerLoad
    );

    const fragment = document.createDocumentFragment();

    batch.forEach(product => {
      const clone = product.cloneNode(true);
      clone.setAttribute('data-infinite-scroll', 'true');

      const images = clone.querySelectorAll('img');
      images.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        img.removeAttribute('loading');
      });

      fragment.appendChild(clone);
    });

    this.container.appendChild(fragment);
    this.bufferIndex += batch.length;

    console.log('⏬ הוצגו', batch.length, 'מוצרים. נשארו בבאפר:', this.buffer.length - this.bufferIndex);

    // אם הבאפר עומד להיגמר, טוען את העמוד הבא ברקע
    if (this.buffer.length - this.bufferIndex <= this.productsPerLoad) {
      const nextPage = this.currentPage + 1;
      if (nextPage <= this.totalPages) {
        this.fetchPage(nextPage);
      }
    }

    this.busy = false;
    this.hideLoading();

    // אם יש עוד מוצרים בבאפר והמשתמש כבר למטה, ממשיך להציג
    if (this.bufferIndex < this.buffer.length || this.currentPage < this.totalPages) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if ((scrollTop + windowHeight) / documentHeight > 0.7) {
        setTimeout(() => this.showNext(), 100);
      }
    }
  }

  showLoading() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    if (this.loader) this.loader.style.display = 'flex';
  }

  hideLoading() {
    if (this.loader) {
      this.hideTimeout = setTimeout(() => {
        this.loader.style.display = 'none';
        this.hideTimeout = null;
      }, 300);
    }
  }
}

// CSS
const style = document.createElement('style');
style.textContent = `
  .infinite-scroll-loader {
    display: none;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
    min-height: 120px;
    width: 100%;
    text-align: center;
  }

  .infinite-scroll-spinner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .infinite-scroll-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f0f0f0;
    border-top: 4px solid #000;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  .infinite-scroll-text {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    margin: 0;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media (max-width: 768px) {
    .infinite-scroll-loader { padding: 50px 20px !important; }
    .infinite-scroll-spinner { width: 60px !important; height: 60px !important; border-width: 5px !important; }
    .infinite-scroll-text { font-size: 16px !important; }
  }

  [data-infinite-scroll="true"] {
    animation: fadeIn 0.4s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;
document.head.appendChild(style);

// התחלה
function startInfiniteScroll() {
  if (document.querySelector('.product-list')) {
    new InfiniteScroll();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startInfiniteScroll);
} else {
  startInfiniteScroll();
}
